import { Component } from "react";
import "../../../../styles/css/table.scss";
import "../../../../App.css";
import apis from "../../../../Providers.Api/apis";
import Helper from "../../../../Common/Helper";
import Spinner from "../../../../Components/Navigation/LoadingSpinner/Spinner";
import { SelectChangeEvent } from "@mui/material/Select";
import { RouteComponentProps, RouterProps } from "react-router-dom";
import { appContext } from "../../../../AppContext";
import IbssDataGrid from "../../../../Components/Data/DataGrid/IbssDataGrid";
import { GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import IbssFormControl from "../../../../Components/Forms/FormControl/IbssFormControl";
import IbssTextField from "../../../../Components/Inputs/TextField/IbssTextField";
import IbssFilterHeader from "../../../../Components/Forms/DateRange/IbssFilterHeader";
import { DateTime } from "luxon";
import IbssButtonRedo from "../../../../Components/Buttons/Button/IbssButton";
import IbssSvgIcon from "../../../../Components/Icons/SvgIcon/IbssSvgIcon";
import CreateIcon from '@mui/icons-material/Create';
import CloseIcon from '@mui/icons-material/Close';
import IbssActionButton, { IActionButton } from "../../../../Components/Buttons/ActionButton/IbssActionButton";
import AddIcon from '@mui/icons-material/Add';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Box, Button, Grid } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import IbssDialog from "../../../../Components/Dialogs/BaseDialog/IbssDialog";
import BookingStatus from "../../../../Components/Miscellaneous/BookingStatus/BookingStatus";
import TimeZoneOffset from "../../../../Components/Miscellaneous/TimeZoneOffset/TimeZoneOffset";
import { ODataQuery } from "../../../../Providers.Api/ODataQuery";
import { Visit2, VisitFilter } from "../../../../Providers.Api/Visits/VisitsRepository";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import React from "react";
import UserPicker, * as UserPickerModule from "../../../../Components/Inputs/UserPicker/UserPicker";
import CreateVisitorDialog from "../../../../Components/Dialogs/CreateVisitorDialog/CreateVisitorDialog";
import RefreshIcon from '@mui/icons-material/Refresh';
import customTheme from "../../../../customTheme";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import { Constants } from "../../../../Common/Constants";
import { StringHelper } from "../../../../Common/StringHelper";
import { QueryParams } from "./QueryParams";
import QRCode from "react-qr-code";
import { renderToString } from 'react-dom/server';
import { DateRangeHelper } from "../../../../Common/DateRangeHelper";
import { rights } from "../../../../Common/RightsManager";
import { IExportRequestsDto } from "../../../../Providers.IbssApiClientV2/IbssApiClientV2";
import PreparingExportDialog from "../../../../Components/Dialogs/PreparingExportDialog/PreparingExportDialog";
import { Space } from "../../../../Providers.Api/Spaces/SpaceRepository";
import ServerDataGrid, { DataGridQueryResult, IDataQuery, IPages } from "../../../../Components/Data/ServerDataGrid/ServerDataGrid";
import { IVisitView, Visit } from "./DataModels";
import { PagedResponse } from "../../../../Providers.Api/Models";

class ListVisits extends IbssPage<IProps, IState, QueryParams>
{
    private get alert() { return appContext().alert; }
    private get appState() { return appContext().state; }
    private get local() { return appContext().localStorageProvider; }
    private get visitsService() { return appContext().visitsService; }
    private get labels() { return appContext().labels; }
    private visitorPassesContainer = React.createRef<HTMLDivElement>();
    private visitorPasses: React.RefObject<HTMLDivElement>[] = [];
    private get apiClient() { return appContext().apiClient; }
    private isFlex = this.area == 'flex';
    private string = new StringHelper();
    private isOnelens = this.area == 'onelens';
    private get apiCache() { return appContext().apiCache; }
    private get hasV2Rights() { return rights.API.Visits.V2.has(); }
    private cachedSpaces: Space[] = [];
    private pageCacheKey = '27a0d6ff-2cd7-fe94-2061-aa192db33bae';
    private dataGridRef = React.createRef<ServerDataGrid<IVisitView>>();
    private get dataGrid() { return this.dataGridRef.current; }

    constructor(props: IProps)
    {
        super(props, new QueryParams());
        this.state =
        {
            canExport: false,
            canImport: false,
            canCreateVisits: false,
            canUpdateVisits: false,
            canReadVisits: false,
            isRefreshButtonDisabled: true,
            searchTerm: "",
            daysFilter: "",
            disableExport: false,
            showPreparingExportPopup: false,
            visits: [],
            bookingStartDate: DateTime.now(),
            bookingEndDate: DateTime.now(),
            filterStatusOption: [
                { label: this.labels.HubTabAwaitingApproval, value: "Awaiting Approval" },
                { label: this.labels.HubLabelCancelled, value: "Cancelled" },
                { label: this.labels.HubLabelDeniedLabel, value: "Denied" },
                { label: this.labels.HubLabelApproved, value: "Approved" },
                { label: this.labels.HubLabelCheckedIn, value: "Checked In" },
                { label: this.labels.HubLabelCheckedOut, value: "Checked Out" },
                { label: this.labels.HubLabelNoShow, value: "No Show" },
                { label: this.labels.HubLabelAutoCancelledStatus, value: "Auto Cancelled" },
            ],
            selectedHost: { label: "", email: "" },
            dialogSelectedHost: { label: "", email: "" },
            dialogHostName: "",
            filterValue: "",
            dateDisabled: true,
            selectedVisitIds: [],
            isCompleteLoading: false,
            cancelButtonEnabled: false,
            approveButtonEnabled: false,
            denyButtonEnabled: false,
            checkInButtonEnabled: false,
            checkOutButtonEnabled: false,
            printPassButtonEnabled: false,
            showDeny: false,
            denyComment: "",
            isFileUpload: false,
            file: { name: "" },
            showPrintPass: false,
            showFilterDialog: false,
            showAddVisitorModal: false,
            buildingId: this.appState.buildingId,
            visitStatus: "",
            badgeHtml: '',
            userHasApproveRights: false,
            userHasDenyRights: false,
            userHasCheckinRights: false,
            userHasCheckoutRight: false,
            pagesOfTask:
            {
                pages: [],
                pageIndex: 0,
                skipToken: '',
            },
        }
    }

    public async componentDidMount(): Promise<void>
    {
        if (this.isOnelens)
        {
            try
            {
                const file = await this.apiClient.files.getFileAsBlob(`c/Badge/${this.state.buildingId}/badge.html`, true);
                const htmlText = await file.text();
                this.setState({ badgeHtml: htmlText });
            } catch (error)
            {
                try
                {
                    const file = await this.apiClient.files.getFileAsBlob(`c/Badge/badge.html`, true);
                    const htmlText = await file.text();
                    this.setState({ badgeHtml: htmlText });
                } catch (error)
                {
                }
            }
        }
    
    }

    private clearCache(): void
    {
        appContext().inMemoryCache.clear(i => i.startsWith(this.pageCacheKey + '_'));
    }

    public async queryParamsDidUpdate(firstLoad: boolean): Promise<void>
    {
        if (firstLoad)
        {
            this.clearCache();
        }

        const string = this.string;
        const queryParams = this.queryParams;
        const buildingId = queryParams.building ?? 1;
        const status = this.state.filterStatusOption.find(i => string.toKebabCase(i.value) == queryParams.status) ?? null;
        const currentUser = this.local.getUserDetails();
        const host = (this.isFlex ? currentUser.email : queryParams.host);
        const defaultPeriod = (this.isFlex ? this.labels.HubLabelThisWeek : this.labels.HubLabelToday);
        
        const dateRange = new DateRangeHelper(buildingId)
        .addToday()
        .addTomorrow()
        .addThisWeek()
        .addNextWeek()
        .addThisMonth()
        .addNextMonth()
        .getDateRange(queryParams.period, defaultPeriod, queryParams.start, queryParams.end);
        
        if (dateRange.isPeriodCustom && (queryParams.period != undefined || queryParams.start != dateRange.start || queryParams.end != dateRange.end))
        {
            return this.pushQueryParams({ period: undefined, start: dateRange.start, end: dateRange.end }, true);
        }
        else if (!dateRange.isPeriodCustom && (queryParams.period != dateRange.period || queryParams.start != undefined || queryParams.end != undefined))
        {
            return this.pushQueryParams({ period: dateRange.period, start: undefined, end: undefined }, true);
        }

        await this.setStateAsync({
            buildingId: buildingId,
            daysFilter: dateRange.period,
            dateDisabled: (dateRange.period != this.labels.HubLabelCustom),
            bookingStartDate: dateRange.start,
            bookingEndDate: dateRange.end,
            filterValue: status?.value ?? '',
            selectedHost: { label: '', email: host ?? '' },
            dialogHostName: host ?? '',
            searchTerm: queryParams.filter ?? '',
            isCompleteLoading: true,
        });
        
        const building = this.local.getNodeData().Regions.flatMap(i => i.Buildings).find(i => i.Node_Id == this.state.buildingId) ?? null;
        this.pageTitle = this.isFlex ? this.labels.HubMenumySchedule : this.labels.HubLabelFacilityManagement + (building == null ? '' : ' - ' + building.Name);
        this.cachedSpaces = await this.apiCache.getSpacesByBuilding(buildingId);
        await this.loadRights(this.state.buildingId);
        await this.dataGrid?.refresh();
        this.enableRefreshButtonAfterTimeOut();       
    }

    private loadRights(buildingId: number): void
    {
        this.setState({
            canExport: rights.API.Visits.Export.has(),
            canImport: rights.API.Visits.Import.has(),
            canCreateVisits: rights.DATAMODEL.Visits.Create.has(),
            canUpdateVisits: rights.DATAMODEL.Visits.Update.has(),
            canReadVisits: rights.DATAMODEL.Visits.Read.has(),
            userHasApproveRights: rights.API.Visits.Approve.has(buildingId),
            userHasDenyRights: rights.API.Visits.Deny.has(buildingId),
            userHasCheckinRights: rights.API.Visits.CheckIn.has(buildingId),
            userHasCheckoutRight: rights.API.Visits.CheckOut.has(buildingId),
        });
    }

    private queuePushQueryParamsTimeout: (NodeJS.Timeout | null) = null;
    private queuePushQueryParams(queryParams: Partial<QueryParams>): void
    {
        clearTimeout(this.queuePushQueryParamsTimeout ?? undefined);
        this.queuePushQueryParamsTimeout = setTimeout(() => this.pushQueryParams(queryParams), Constants.longDebounceTimeInMilliseconds);
    }

    private async dataQueryChanged(gridQuery: IDataQuery): Promise<DataGridQueryResult<IVisitView>>    
    {
        let filter = {
            minStartDate: this.state.bookingStartDate.date().setZoneByNode(this.state.buildingId),
            maxEndDate: this.state.bookingEndDate.date().plus({ days: 1 }).setZoneByNode(this.state.buildingId),
            status: this.state.filterValue,
            hostEmail: this.state.selectedHost.email,
        }

        let filterParts = new Array<string>();
        filterParts.push(filter.minStartDate.isValid ? `Visit_Start_Date ge datetime'${filter.minStartDate.toUTC().toISO()}'` : "");
        filterParts.push(filter.maxEndDate.isValid ? `Visit_Start_Date lt datetime'${filter.maxEndDate.toUTC().toISO()}'` : "");
        filterParts.push(filter.status != "" ? `Visit_Status eq '${filter.status}'` : "");
        filterParts.push(filter.hostEmail != "" ? `Visit_Host_Email eq '${filter.hostEmail.toLocaleLowerCase()}'` : "");
        const filterString = filterParts.filter(i => i != "").join(" and ");

        try
        {
            this.setState({ isCompleteLoading: true });
            const endpoint = {
                name: 'visitsService.getMany',
                options: {
                    top: 200,
                    nodeId: this.state.buildingId,
                    select: Visit,
                    filter: filterString,
                    skipToken: gridQuery.skipToken,
                }
            };

            if(this.hasV2Rights)
            {                
                const visits = await appContext().inMemoryCache.lazyGetWithQuickExpiry(
                    `${this.pageCacheKey}_${JSON.stringify(endpoint)}`,
                    () => appContext().ibssApiClientV2.v2.byNodeid.visits.get<PagedResponse<IVisitView[]>>
                    (
                        endpoint.options
                    )
                );
                await this.setStateAsync({ visits: visits.value });
                return new DataGridQueryResult(visits.value, visits.skipToken);

            } 
            else 
            {
                const visitors = await appContext().ibssApiClientV1.v1.byNodeid.visits.get<IVisitView[]>({
                    nodeId: endpoint.options.nodeId,
                    select: endpoint.options.select,
                    filter: endpoint.options.filter,
                    top: 301,
                    schema: false,
                    showDebugStats: false
                });
                await this.setStateAsync({ visits: visitors});
                return new DataGridQueryResult(visitors,"");
            }
                
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private filteredVisits(searchTerm: string): IPages<IVisitView>
    {
        const lowerSearchTerm = searchTerm.toLowerCase();

        const filteredVisits = this.state.visits.filter(visit =>
        {
            let key: keyof IVisitView;
            for (key in visit)
            {
                const value = visit[key]?.toString().toLowerCase();
                if (value && value.includes(lowerSearchTerm)) 
                {
                    return true;
                }
            }
            return false;
        });
        return { pages: [{ rows: filteredVisits }], skipToken: '', pageIndex: 0 } 
    }

    private get selectedVisits(): IVisitView[]
    {
        return this.state.visits.filter(row => this.state.selectedVisitIds.includes(row.Visit_Id));
    }
    
    private async tasksSelected(selection: GridRowSelectionModel)
    {
        await this.setStateAsync({ selectedVisitIds: selection });
        this.enableDisableActionButtons();
    }
    
    private enableDisableActionButtons(): void
    {
        const selectedVisits = this.selectedVisits;
        const cancellableRows = selectedVisits.filter(i => i.Visit_Status == "New" || i.Visit_Status == "Amended" || i.Visit_Status == "Late Checkin" || i.Visit_Status == "Awaiting Approval" || i.Visit_Status == "Approved");
        const approvableRows = selectedVisits.filter(i => i.Visit_Status == "Awaiting Approval");
        const checkInableRows = selectedVisits.filter(i => i.Visit_Status == "Approved");
        const checkOutableRows = selectedVisits.filter(i => i.Visit_Status == "Checked In");
        const printableRows = selectedVisits.filter(i => i.Visit_Status == "Checked In" || i.Visit_Status == "Approved");

        this.setState({
            cancelButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == cancellableRows.length),
            approveButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == approvableRows.length),
            denyButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == approvableRows.length),
            checkInButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == checkInableRows.length),
            checkOutButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == checkOutableRows.length),
            printPassButtonEnabled: (selectedVisits.length > 0 && selectedVisits.length == printableRows.length) && (rights.ONELENS360.OperationalServices.VisitorPass.has(this.state.buildingId)),
        });
    }

    private async cancelManyClicked(): Promise<void>
    {
        this.setState({ isCompleteLoading: true });
        let message = "";
        const selectedVisitsByNodeId: { [key: number]: IVisitView[] } = {};

        this.selectedVisits.forEach(visit =>
        {
            if (!Object.hasOwnProperty.call(selectedVisitsByNodeId, visit.Node_Id)) 
            {
                selectedVisitsByNodeId[visit.Node_Id] = [];
            }
            selectedVisitsByNodeId[visit.Node_Id].push(visit);
        });

        try 
        {
            for (const nodeId in selectedVisitsByNodeId) 
                {
                    if (Object.hasOwnProperty.call(selectedVisitsByNodeId, nodeId)) 
                        {
                            const selectedVisitIdsForNodeId = selectedVisitsByNodeId[nodeId].map(x => x.Visit_Id)
                            await this.visitsService.cancel(Number(nodeId), selectedVisitIdsForNodeId);
                        }
                    }
            this.clearCache();
            await this.dataGrid?.refresh();
            this.enableDisableActionButtons();
            this.alert.show("", message);
            await this.dataGrid?.refresh();
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private async approveVisitorClicked(): Promise<void>
    {
        this.setState({ isCompleteLoading: true });
        let message = "";

        const selectedVisitIds = this.selectedVisits.map(x => x.Visit_Id);
        try
        {
            await this.visitsService.approve(this.appState.buildingId, selectedVisitIds, '')
            this.clearCache();
            await this.dataGrid?.refresh();
            this.enableDisableActionButtons();
            this.alert.show("", message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private async denyVisitorClicked(): Promise<void>
    {
        this.setState({ isCompleteLoading: true });
        let message = "";

        const selectedVisitIds = this.selectedVisits.map(x => x.Visit_Id);

        try
        {
            await this.visitsService.deny(this.appState.buildingId, selectedVisitIds, this.state.denyComment);
            this.clearCache();
            await this.dataGrid?.refresh();
            this.enableDisableActionButtons();
            this.alert.show("", message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false, showDeny: false });
        }
    }

    private async checkInVisitorClicked(): Promise<void>
    {
        this.setState({ isCompleteLoading: true });
        let message = "";

        const body = this.selectedVisits.map(visit => ({
            Visit_Id: visit.Visit_Id,
            VisitorTypeWorkflow: visit.CheckInWorkflow ? JSON.parse(visit.CheckInWorkflow) : { Steps: [] }
        }));

        try
        {
            await appContext().ibssApiClientV2.v2.byNodeid.visits.checkin.post({
                nodeId: this.appState.buildingId,
                body: body
            });
            this.clearCache();
            await this.dataGrid?.refresh();
            this.enableDisableActionButtons();
            this.alert.show("", message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private async checkOutVisitorClicked(): Promise<void>
    {
        this.setState({ isCompleteLoading: true });
        let message = "";

        const selectedVisitIds = this.selectedVisits.map(x => x.Visit_Id)
        try
        {
            await this.visitsService.checkout(this.appState.buildingId, selectedVisitIds)
            this.clearCache();
            await this.dataGrid?.refresh();
            this.enableDisableActionButtons();
            this.alert.show("", message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private async hostChanged(selectedHost: UserPickerModule.IUser | null): Promise<void>
    {
        this.setState({
            dialogSelectedHost: {
                label: selectedHost?.label || selectedHost?.email || "",
                email: selectedHost?.email ?? "",
            }
        });
    }

    private async dateRangeChanged(e: SelectChangeEvent<string>): Promise<void>
    {
        const datePreset = this.string.toKebabCase(e.target.value);
        const customPeriod = this.string.toKebabCase(this.labels.HubLabelCustom);
        const datePresetIsCustom = (datePreset == customPeriod);

        this.pushQueryParams({
            period: datePreset,
            start: (datePresetIsCustom ? this.state.bookingStartDate : undefined),
            end: (datePresetIsCustom ? this.state.bookingEndDate : undefined),
        });
    }

    private async startDateChanged(e: DateTime): Promise<void>
    {
        await this.setStateAsync({ isCompleteLoading: true });
        this.queuePushQueryParams({ start: e });
    }

    private async endDateChanged(e: DateTime): Promise<void>
    {
        await this.setStateAsync({ isCompleteLoading: true });
        this.queuePushQueryParams({ end: e });
    }

    private denyModelCancelled(): void 
    {
        this.setState({ showDeny: !this.state.showDeny });
    }

    private denyButtonClicked(): void
    {
        this.setState({ showDeny: !this.state.showDeny });
    }

    private fileUploadModalClosed(): void
    {
        this.setState({ isFileUpload: !this.state.isFileUpload });
    }

    private selectedFileChanged(e: React.ChangeEvent<HTMLInputElement>) 
    {
        this.setState({ file: e.target.files?.[0] });
    }

    private async uploadFileButtonClicked(): Promise<void> 
    {
        this.setState({ isCompleteLoading: true });
        this.fileUploadModalClosed();
        const formData = new FormData();

        const file = (this.state.file ? this.state.file : "");
        formData.append('file', file as string);
        formData.append('fileName', (file as IFile).name);

        try
        {
            const res = await apis.visitorImportFile(this.appState.buildingId, formData);
            if (res.status === 200)
            {
                let messageHtml = `<h2>${this.labels.HubLabelFileuploadedsuccessfully}</h2> </br>`;

                const erroredEntries = res.data.filter((x: { ImportSuccessful: boolean; }) => x.ImportSuccessful == false);
                const successfulEntries = res.data.filter((x: { ImportSuccessful: boolean; }) => x.ImportSuccessful == true);

                if (erroredEntries.length > 0)
                {
                    messageHtml = `<h2>${successfulEntries.length}/${res.data.length} ${this.labels.HubLabelEntriesUploadedSuccessfully}</h2><h3>${this.labels.HubLabelIssuesOccured}:</h3>` + res.data.filter((x: { ImportSuccessful: boolean; }) =>
                        x.ImportSuccessful == false).map((i: { Error: { RowNo: number, Message: string } }) =>
                            `<span>${this.labels.HubLabelRow} ${i.Error?.RowNo ? i.Error?.RowNo + 1 : '-'} ${i.Error?.Message?.length > 0 ? `- ${i.Error?.Message}` : ''}</span> </br>`).join('');
                }
                this.alert.show("", messageHtml, () => { }, { messageIsHtml: true });
            }
            else
            {
                this.alert.show("", res.statusText ?? this.labels.HubLabelSomethingWentWrong);
            }
        }
        catch (error)
        {
            const typedError = error as { Message: string };
            this.alert.show("", typedError.Message);
        }
        finally
        {
            this.setState({ isCompleteLoading: false });
        }
    }

    private async downloadVisitsClicked(): Promise<void> 
    {
        this.setState({ disableExport: true, showPreparingExportPopup: true });
        setTimeout(() => this.setState({ disableExport: false }), 60000);

        const startDate = this.state.bookingStartDate.toUTC().toISO();
        const endDate = this.state.bookingEndDate.toUTC().toISO();

        let statusFilter = '';
        if (this.state.filterValue)
        {
            statusFilter = ` and Visit_Status eq '${this.state.filterValue}'`;
        }

        let hostFilter = '';
        if (this.state.selectedHost.email)
        {
            hostFilter = ` and Visit_Host_Email eq '${this.state.selectedHost.email.toLowerCase()}'`;
        }

        const filteredVisitorsObj: IExportRequestsDto = {
            Node_Id: this.state.buildingId,
            Filter: `Visit_Start_Date ge datetime'${startDate}' and Visit_End_Date lt datetime'${endDate}'${statusFilter}${hostFilter}`,
            Source: "oneLens"
        };

        try
        {
            appContext().ibssApiClientV2.v2.byNodeid.visits.download.post({
                nodeId: this.state.buildingId,
                body: filteredVisitorsObj 
           });
       }
       catch (error) { }
    }

    private async printPassButtonClicked(): Promise<void>
    {
        this.visitorPasses = this.state.selectedVisitIds.map(() => React.createRef());
        await this.setStateAsync({ showPrintPass: !this.state.showPrintPass });
        const selectedVisitors = this.state.visits.filter(x => this.state.selectedVisitIds.includes(x.Visit_Id));

        let imageUrl = '';
        const firstVisitLogo = this.visitorPasses[0].current?.querySelector(`#visit-logo`);
        if (firstVisitLogo)
        {
            const fileBlob = await this.apiClient.files.getFileAsBlob(firstVisitLogo.innerHTML);
            imageUrl = URL.createObjectURL(fileBlob);
        }

        selectedVisitors.forEach(async (visitor, index) =>
        {
            const visitorPass = this.visitorPasses[index].current;
            const qrCodeType = this.visitorPasses[index].current?.querySelector(`#qr-code`)?.innerHTML.split('-')[0];
            const qrCodeSize = this.visitorPasses[index].current?.querySelector(`#qr-code`)?.innerHTML.split('-')[1];
            const qrCodeValue = qrCodeType == 'pacs' ? visitor.Visit_Pacs_Id : qrCodeType == 'visitId' ? visitor.Visit_Id : '';
            if (visitorPass == null)
            {
                return;
            }

            const startDate = visitor.Visit_Start_Date
            const endDate = visitor.Visit_End_Date

            const visitorName = visitorPass.querySelector(`#visitor-name`);
            const visitorCompany = visitorPass.querySelector(`#visitor-company`);
            const visitDate = visitorPass.querySelector(`#visit-date`);
            const visitTime = visitorPass.querySelector(`#visit-time`);
            const visitHost = visitorPass.querySelector(`#visit-host`);
            const visitLogo = visitorPass.querySelector(`#visit-logo`);
            const qrCode = visitorPass.querySelector(`#qr-code`);

            if (visitorName) visitorName.innerHTML = visitor.Visitor_First_Name + ' ' + visitor.Visitor_Last_Name;
            if (visitorCompany) visitorCompany.innerHTML = visitor.Visitor_Company;
            if (visitDate) visitDate.innerHTML = startDate.toLocaleDateString();
            if (visitTime) visitTime.innerHTML = startDate.toLocaleTimeString() + ' - ' + endDate.toLocaleTimeString();
            if (visitHost) visitHost.innerHTML = visitor.Visit_Host_Name;
            if (visitLogo) visitLogo.innerHTML = `<img src=${imageUrl}>`;
            if (qrCode) qrCode.innerHTML = renderToString((qrCodeType == 'pacs' && visitor.Visit_Pacs_Id.length > 0) || qrCodeType == 'visitId' ? <QRCode size={qrCodeSize ? parseInt(qrCodeSize) : undefined} value={qrCodeValue} /> : <div></div>);

        });
    }

    private addVisitButtonClicked(): void
    {
        this.setState({ showAddVisitorModal: true });
    }

    private editVisitButtonClicked(param: Visit2): void
    {
        const { history } = this.props;
        if (this.isFlex)
        {
            history.push(`/flex-my-visitor/${param.Node_Id}/myvisit/${param.Visit_Id}`);
        }
        else
        {
            history.push(`/operational-services-Visitors/${this.appState.buildingId}/visit/${param.Visit_Id}/1`);
        }
    }

    private async filterButtonClicked(): Promise<void>
    {
        await this.setStateAsync({
            showFilterDialog: true,
            dialogHostName: this.state.selectedHost.email,
            dialogSelectedHost: { label: this.state.selectedHost.label, email: this.state.selectedHost.email },
        });
    }

    private filterModalClosed(): void
    {
        this.setState({ showFilterDialog: false });
    }

    private async filterModalOkButtonClicked(): Promise<void>
    {
        try
        {
            this.pushQueryParams({
                status: this.string.toKebabCase(this.state.filterValue),
                host: (this.isFlex ? undefined : this.state.dialogSelectedHost.email),
            });
        }
        finally
        {
            this.setState({ showFilterDialog: false });
        }
    }

    private async modalClosed(submitted?: boolean): Promise<void>
    {
        this.setState({ showAddVisitorModal: !this.state.showAddVisitorModal });
        if (submitted)
        {
            this.clearCache();
            await this.dataGrid?.refresh();
        }
    }

    private enableRefreshButtonAfterTimeOut(): void
    {
        setTimeout(() =>
        {
            this.setState({ isRefreshButtonDisabled: false });
        }, 60000);
    }

    private async handleRefreshButtonClick(): Promise<void>
    {
        this.setState({ isRefreshButtonDisabled: true });
        await this.dataGrid?.refresh();
        this.enableRefreshButtonAfterTimeOut();
    }

    private async handleSearchTermChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): Promise<void>
    {
        this.setState({ searchTerm: event.target.value });
        this.queuePushQueryParams({ filter: event.target.value });
    }

    private getFloorName(spaceId: string): React.ReactNode 
    {
        const Id = spaceId.split(";")[0];
        const floors = Helper.getFloorsByBuildingId(this.state.buildingId);
        const floorNodeId = this.cachedSpaces.find(x => x.Space_Id === Id)?.Node_Id;
        return floors.find(x => x.Node_Id === floorNodeId)?.Node_Name;
    }

    public render(): JSX.Element
    {
        const visitColumns: GridColDef[] = [
            {
                headerName: this.labels.HubLabelDate,
                field: "Date",
                minWidth: 140,
                flex: 1,
                sortable: false,
                renderCell: (params) => params.row.Visit_Start_Date.toLocaleDateString(),
            },
            {
                headerName: this.labels.HubLabelArrival,
                field: "Visit_Start",
                minWidth: 140,
                flex: 1,
                sortable: false,
                renderCell: (params) => params.row.Visit_Start_Date.toLocaleString(DateTime.TIME_24_SIMPLE),
            },
            {
                headerName: this.labels.HubLabelDeparture,
                field: "Visit_End",
                minWidth: 140,
                flex: 1,
                sortable: false,
                renderCell: (params) => params.row.Visit_End_Date.toLocaleString(DateTime.TIME_24_SIMPLE),
            },
            {
                headerName: this.labels.HubLabelTimeZone,
                cellClassName: "table-cell-font",
                field: "timeZone",
                minWidth: 100,
                flex: 1,
                sortable: false,
                renderCell: (params) => <TimeZoneOffset nodeId={params.row.Node_Id} />
            },
            {
                headerName: this.labels.HubLabelvisitor,
                field: "Visitor_Name",
                minWidth: 120,
                flex: 1,
                sortable: false,
                valueGetter: (params) => params.row.Visitor_First_Name + ' ' + params.row.Visitor_Last_Name
            },
            {
                headerName: this.labels.HubLabelCompany,
                field: Helper.nameOf<Visit2>("Visitor_Company"),
                minWidth: 140,
                sortable: false,
                flex: 1
            },
            {
                headerName: this.labels.funcDestination_S,
                field: Helper.nameOf<Visit2>("Space_Name"),
                minWidth: 140,
                flex: 1,
                sortable: false,
                valueGetter: (params) => params.row.Space_Name?.length > 0 ? params.row.Space_Name : '-'
            },
            {
                headerName: this.labels.HubLabelFloors,
                field: "Floor",
                minWidth: 140,
                flex: 1,
                sortable: false,
                renderCell: (params) => params.row.Space_Id ? this.getFloorName(params.row.Space_Id) : '-'
            },
            {
                headerName: this.labels.HubLabelAction,
                minWidth: 100,
                flex: 1,
                field: "",
                filterable: false,
                sortable: false,
                renderCell: (params) => this.renderEdit(params.row)
            },
            {
                headerName: this.labels.HubLabelStatus,
                field: "Visit_Status",
                minWidth: 140,
                flex: 1,
                sortable: false,
                renderCell: (params) => <BookingStatus status={params.row.Visit_Status} />,
                valueGetter: (params) => params.row.Visit_Status,
            }];

        if (!this.isFlex)
        {
            visitColumns.splice(5, 0,
                {
                    headerName: this.labels.HubLabelHostName,
                    field: Helper.nameOf<Visit2>("Visit_Host_Name"),
                    minWidth: 160,
                    sortable: false,
                    flex: 1
                })
        }

        let actions: IActionButton[] = [
            {
                label: this.labels.funcRefreshBookings_S,
                icon: (
                    <IbssSvgIcon>
                        <RefreshIcon />
                    </IbssSvgIcon>),
                color: "inherit",
                labelColor: this.appState.lightModeTheme ? customTheme.lightTheme.uiTextAlternate : customTheme.darkTheme.uiText,
                onClick: () => this.handleRefreshButtonClick(),
                disabled: this.state.isRefreshButtonDisabled
            },
            {
                label: this.labels.HubButtonApprove,
                icon: (
                    <IbssSvgIcon>
                        <CheckCircleIcon />
                    </IbssSvgIcon>),
                color: "primary",
                disabled: !this.state.approveButtonEnabled || !this.state.userHasApproveRights,
                onClick: () => this.approveVisitorClicked()
            },
            {
                label: this.labels.HubButtonDeny,
                icon: (
                    <IbssSvgIcon>
                        <CloseIcon />
                    </IbssSvgIcon>
                ),
                color: "primary",
                disabled: !this.state.denyButtonEnabled || !this.state.userHasDenyRights,
                onClick: () => this.denyButtonClicked()
            },
            {
                label: this.labels.HubButtonCancel,
                icon: (
                    <IbssSvgIcon>
                        <CloseIcon />
                    </IbssSvgIcon>),
                color: "error",
                disabled: !this.state.cancelButtonEnabled || !this.state.canUpdateVisits,
                onClick: () => this.cancelManyClicked(),
            },
            {
                label: this.labels.HubButtonCheckIn,
                icon: (
                    <IbssSvgIcon>
                        <CheckCircleIcon />
                    </IbssSvgIcon>),
                color: "primary",
                disabled: !this.state.checkInButtonEnabled || !this.state.userHasCheckinRights,
                onClick: () => this.checkInVisitorClicked()
            },
            {
                label: this.labels.HubButtonCheckOut,
                icon: (
                    <IbssSvgIcon>
                        <CancelIcon />
                    </IbssSvgIcon>),
                color: "primary",
                disabled: !this.state.checkOutButtonEnabled || !this.state.userHasCheckoutRight,
                onClick: () => this.checkOutVisitorClicked()
            },
            {
                label: this.labels.HubButtonPrintPass,
                icon: (
                    <IbssSvgIcon>
                        <AccountBalanceWalletIcon />
                    </IbssSvgIcon>),
                color: "primary",
                disabled: !this.state.printPassButtonEnabled || this.state.badgeHtml == '',
                onClick: () => this.printPassButtonClicked()
            },
            {
                label: this.labels.HubButtonAdd,
                icon: (
                    <IbssSvgIcon>
                        <AddIcon />
                    </IbssSvgIcon>
                ),
                color: "primary",
                disabled: !this.state.canCreateVisits,
                onClick: () => this.addVisitButtonClicked(),
            }];

        if (this.isFlex)
        {
            actions = actions.filter(i => i.label == this.labels.HubButtonCancel || i.label == this.labels.HubButtonAdd || i.label == this.labels.funcRefreshBookings_S);
        }

        const filteredVisits = this.filteredVisits(this.state.searchTerm);


        return (
            <>
                <div className="">
                    <PreparingExportDialog open={this.state.showPreparingExportPopup} onClose={() => this.setState({ showPreparingExportPopup: false })} />
                    
                    {this.state.isCompleteLoading && <Spinner />}
                    <IbssDialog
                        aria-modal="true"
                        aria-label="filter visitors modal"
                        onClose={() => this.filterModalClosed()}
                        open={this.state.showFilterDialog}
                        header={this.labels.HubLabelFilter}
                        fullWidth
                        dialogContent={
                            <>
                                <div className="row">
                                    <div className="form-input-box">
                                        <label className="form-input-box-label visit-filter-label">{this.labels.HubLabelStatus}</label>
                                        <div className="form-input-select-box">
                                            <select className="custom-form-control visit-filter-selectbox select-box-border" onChange={(e) => this.setState({ filterValue: e.target.value })} value={this.state.filterValue} >
                                                <option></option>
                                                {this.state.filterStatusOption.map((option: IFilterStatus) => (
                                                    <option key={option.value} value={option.value}>{option.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {!this.isFlex &&
                                    <div className="row">
                                        <div className="form-input-box">
                                            <label className="form-input-box-label visit-filter-label">{this.labels.HublabelHostVisitFilter}</label>
                                            <UserPicker
                                                width="calc(100% - 110px)"
                                                searchText={this.state.dialogHostName}
                                                label=""
                                                placeholder="&#8230;"
                                                alternateStyle={true}
                                                onChange={async text => await this.setStateAsync({ dialogHostName: text })}
                                                onUserChange={user => this.hostChanged(user)}
                                            />
                                        </div>
                                    </div>
                                }
                            </>
                        }
                        footer={
                            <>
                                <IbssButtonRedo
                                    onClick={() => this.filterModalClosed()}
                                    color="secondary"
                                    variant="outlined"
                                    className="mr-2"
                                >
                                    {this.labels.HubButtonCancel}
                                </IbssButtonRedo>
                                <IbssButtonRedo
                                    color="primary"
                                    variant="contained"
                                    size="medium"
                                    className="ml-2"
                                    onClick={() => this.filterModalOkButtonClicked()}
                                >
                                    {this.labels.HubLabelOk}
                                </IbssButtonRedo>
                            </>
                        }
                    />
                    <IbssDialog
                        aria-modal="true"
                        aria-label="import visitors modal"
                        onClose={() => this.fileUploadModalClosed()}
                        open={this.state.isFileUpload}
                        header={this.labels.HublabelUploadFile}
                        fullWidth
                        dialogContent={
                            <>
                                <div className="row mt-3">
                                    <div className="col-3 pl-0 ">
                                        <label className="upload-file-modal-label pr-0">{this.labels.HubLabelFile}</label>
                                    </div>
                                    <div className="col-8 pl-0 file-picker">
                                        <input className="upload-file-modal-input" value={this.state.file?.name} type="text" readOnly></input>
                                        <label htmlFor="filePicker" className="button-outline file-picker-label mr-1">{this.labels.HubLabeSelectFile}</label>
                                        <input id="filePicker" className="hideInput" type={"file"} onChange={(e) => this.selectedFileChanged(e)}></input>
                                    </div>
                                </div>
                            </>
                        }
                        footer={
                            <>
                                <div className="d-flex justify-content-center w-100">
                                    <IbssButtonRedo
                                        onClick={() => this.fileUploadModalClosed()}
                                        color="secondary"
                                        variant="outlined"
                                        className="mr-2"
                                    >
                                        {this.labels.HubButtonCancel}
                                    </IbssButtonRedo>
                                    <IbssButtonRedo
                                        color="primary"
                                        variant="contained"
                                        size="medium"
                                        className="ml-2"
                                        onClick={() => this.uploadFileButtonClicked()}
                                    >
                                        {this.labels.HubLabelOk}
                                    </IbssButtonRedo>
                                </div>
                            </>
                        }
                    />
                    <IbssDialog
                        aria-modal="true"
                        aria-label="deny modal"
                        onClose={() => this.denyModelCancelled()}
                        open={this.state.showDeny}
                        header={this.labels.HubButtonDeny}
                        fullWidth
                        dialogContent={
                            <>
                                <div className="col-12">
                                    <label>{this.labels.HubLabelComment}</label>
                                    <input className="input-box border model-textbox" type="text" name="denyComment" value={this.state.denyComment} onChange={(e) => this.setState({ denyComment: e.target.value })} />
                                </div>
                            </>
                        }
                        footer={
                            <>
                                <IbssButtonRedo
                                    color="secondary"
                                    variant="outlined"
                                    className="mr-2" onClick={() => this.denyModelCancelled()}>{this.labels.HubButtonCancel}
                                </IbssButtonRedo>
                                <IbssButtonRedo
                                    color="primary"
                                    variant="contained"
                                    size="medium"
                                    disabled={!this.state.denyComment}
                                    onClick={() => this.denyVisitorClicked()}>{this.labels.HubLabelOk}
                                </IbssButtonRedo>
                            </>
                        }
                    />
                    {/* --Print pass modal-- */}
                    <IbssDialog
                        aria-modal="true"
                        aria-label="print pass modal"
                        onClose={() => this.setState({ showPrintPass: !this.state.showPrintPass })}
                        fullWidth
                        open={this.state.showPrintPass}
                        dialogContent={
                            <>
                                <div ref={this.visitorPassesContainer}>
                                    {
                                        this.state.selectedVisitIds.map((id, index) => (
                                            <div key={id} ref={this.visitorPasses[index]} dangerouslySetInnerHTML={{ __html: this.state.badgeHtml }}></div>
                                        ))
                                    }
                                </div>
                            </>
                        }
                        footer={
                            <>
                                <IbssButtonRedo
                                    color="secondary"
                                    variant="outlined"
                                    className="mr-2" onClick={() => this.setState({ showPrintPass: !this.state.showPrintPass })}>{this.labels.HubButtonCancel}
                                </IbssButtonRedo>
                                <ReactToPrint
                                    content={() => this.visitorPassesContainer.current}
                                    onAfterPrint={() => this.setState({ showPrintPass: false })}
                                    removeAfterPrint
                                >
                                    <PrintContextConsumer>
                                        {({ handlePrint }) => (
                                            <IbssButtonRedo
                                                color="primary"
                                                variant="contained"
                                                size="medium"
                                                className="ml-2" onClick={handlePrint}>{this.labels.HubButtonPrint}
                                            </IbssButtonRedo>
                                        )}
                                    </PrintContextConsumer>
                                </ReactToPrint>
                            </>
                        }
                    />
                    <CreateVisitorDialog
                        showCreateVisitorDialog={this.state.showAddVisitorModal}
                        closeClicked={(submitted) => this.modalClosed(submitted)}
                    />
                    <div className="page-height-exct-header">
                        <div className="rightPanel-main-content">
                            <div className="table-panel">
                                <IbssFilterHeader
                                    title={this.isFlex ? this.labels.HubLabelMyVisitors : this.labels.funcVisitors_S}
                                    selectedPreset={this.state.daysFilter}
                                    presetChanged={(e) => this.dateRangeChanged(e)}
                                    startDate={this.state.bookingStartDate.toJSDate()}
                                    endDate={this.state.bookingEndDate.toJSDate()}
                                    datesDisabled={this.state.dateDisabled}
                                    onStartDateChange={i => this.startDateChanged(i)}
                                    onEndDateChange={i => this.endDateChanged(i)}
                                    presets={[this.labels.HubLabelTomorrow, this.labels.HubLabelThisWeek, this.labels.HubLabelNextWeek, this.labels.HubLabelThisMonth, this.labels.HubLabelNextMonth]}
                                />
                                <Grid container rowSpacing={1} sx={{ display: 'flex', alignItems: 'center', mt: 0, ml: 0 }}>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box
                                            sx={{
                                                '& > :not(style)': { mr: 2, my: 1, alignItems: "center" },
                                            }}
                                        >
                                            <IbssFormControl>
                                                <IbssTextField
                                                    variant="outlined"
                                                    size="small"
                                                    label={this.labels.HubLabelSearch}
                                                    value={this.state.searchTerm}
                                                    onChange={(event) => this.handleSearchTermChange(event)}
                                                />
                                            </IbssFormControl>
                                            <IbssButtonRedo color="primary" className="mr-2" variant="contained" onClick={() => this.filterButtonClicked()}>{this.labels.HubLabelFilter}</IbssButtonRedo>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'right' }}>
                                        {this.state.canExport && this.isOnelens && <IbssButtonRedo color="secondary" className="mr-2" variant="contained" onClick={() => this.downloadVisitsClicked()} disabled={this.state.disableExport}>{this.labels.HubButtonExport}</IbssButtonRedo>}
                                        {this.state.canImport && <IbssButtonRedo color="secondary" variant="contained" onClick={() => this.fileUploadModalClosed()}>{this.labels.HubButtonImport}</IbssButtonRedo>}
                                    </Grid>
                                </Grid>
                                <Box component="div" sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', my: 1, mr: 0 }}>
                                    <IbssActionButton buttons={actions} />
                                </Box>
                                <Box sx={{ mt: 1 }}>
                                    <ServerDataGrid
                                        ref={this.dataGridRef}
                                        getRowId={(row) => row.Visit_Id}
                                        loadDataOnMount={false}
                                        checkboxSelection
                                        columns={visitColumns}
                                        disableRowSelectionOnClick
                                        pageSizeOptions={[100]}
                                        pages={this.state.searchTerm.length > 0 ? filteredVisits : this.state.pagesOfTask}
                                        onDataQueryChange={i => this.dataQueryChanged(i)}
                                        onPagesChange={pages => this.setStateAsync({ pagesOfTask: pages })}
                                        onRowSelectionModelChange={(rowSelectionModel: GridRowSelectionModel) => this.tasksSelected(rowSelectionModel)}
                                    />
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    private renderEdit(row: Visit2): React.ReactNode
    {
        return (
            this.state.canReadVisits ?
                <Button sx={{ color: (theme) => theme.palette.text.secondary }} onClick={() => this.editVisitButtonClicked(row)}>
                    <IbssSvgIcon className="pointer">
                        <CreateIcon />
                    </IbssSvgIcon>
                </Button> : <p>-</p>
        );
    }
}

export interface IProps extends RouterProps, RouteComponentProps
{
}

export interface IState
{
    canExport: boolean;
    canImport: boolean;
    canCreateVisits: boolean;
    canUpdateVisits: boolean;
    canReadVisits: boolean;
    isRefreshButtonDisabled: boolean;
    searchTerm: string;
    daysFilter: string;
    bookingStartDate: DateTime;
    bookingEndDate: DateTime;
    dateDisabled: boolean;
    selectedVisitIds: GridRowSelectionModel;
    visits: IVisitView[];
    isCompleteLoading: boolean;
    cancelButtonEnabled: boolean;
    approveButtonEnabled: boolean;
    denyButtonEnabled: boolean;
    checkInButtonEnabled: boolean;
    checkOutButtonEnabled: boolean;
    printPassButtonEnabled: boolean;
    showDeny: boolean;
    denyComment: string;
    isFileUpload: boolean;
    showPrintPass: boolean;
    file: IFile | undefined;
    filterStatusOption: IFilterStatus[];
    filterValue: string;
    showFilterDialog: boolean;
    selectedHost: IHost;
    dialogSelectedHost: IHost;
    dialogHostName: string;
    showAddVisitorModal: boolean;
    buildingId: number;
    visitStatus: string;
    badgeHtml: string;
    userHasApproveRights: boolean;
    userHasDenyRights: boolean;
    userHasCheckinRights: boolean;
    userHasCheckoutRight: boolean;
    disableExport: boolean;
    showPreparingExportPopup: boolean;
    pagesOfTask: IPages<IVisitView>;
}

export interface IFilterStatus
{
    label: string;
    value: string;
}

export interface IHost
{
    label: string;
    email: string;
}

export interface IFile
{
    name: string;
}

export default ListVisits;
